export default class User {
  constructor({ uuid, name = '', email, avatar, bio, title, phone, facebookUrl, externalId = null, active = false, sponsor = false }) {
    this.uuid = uuid;
    this.name = name;
    this.email = email;
    this.avatar = avatar;
    this.bio = bio;
    this.title = title;
    this.phone = phone;
    this.facebookUrl = facebookUrl;
    this.sponsor = sponsor;
    this.externalId = externalId;
    this.active = active;
    this.channelId = null;
  }
}